export const PERMISSIONS = {
  Admin: {
    Users: {
      Preview: 'admin.users.preview',
    },
    
    VersionInformation: {
      Publish: 'admin.version-information.publish',
    },

    Dashboard: {
      View: 'admin.dashboard.view',
    },

    Subscriptions: {
      View: 'admin.subscriptions.view',
      Manage: 'admin.subscriptions.manage',
    },

    UserRoles: {
      View: 'admin.user-roles.view',
      Manage: 'admin.user-roles.manage',
    },

    ReportedProblems: {
      View: 'admin.reported-problems.view',
      Manage: 'admin.reported-problems.manage',
    },

    DeviceTypes: {
      View: 'admin.device-types.view',
      Manage: 'admin.device-types.manage',
    },

    Materials: {
      View: 'admin.materials.view',
      Manage: 'admin.materials.manage',
    },

    TermsOfUse: {
      Publish: 'admin.terms-of-use.publish',
    },

    PrivacyPolicy: {
      Publish: 'admin.privacy-policy.publish',
    },

    Organizations: {
      View: 'admin.organizations.view',
      Manage: 'admin.organizations.manage',
    },

    Statistics: {
      Organizations: {
        View: 'admin.statistics.organizations.view',
      },

      Global: {
        View: 'admin.statistics.global.view',
      },

      Devices: {
        View: 'admin.statistics.devices.view',
      },
    },
  },
  
  Teams: {
    View: 'teams.view',
    Manage: 'teams.manage',
  },

  Devices: {
    View: 'devices.view',
    RegisteredView: 'devices.registered.view',
    Create: 'devices.create',
    Edit: 'devices.edit',
    Delete: 'devices.delete',

    Details: {
      View: 'devices.details.view',
      SpecificationView: 'devices.specification.view',
      LogsView: 'devices.logs.view',
      HistoryView: 'devices.history.view',
    },

    Commands: {
      Start: 'devices.commands.start',
      Pause: 'devices.commands.pause',
      Stop: 'devices.commands.stop',
      Resume: 'devices.commands.resume',
      Update: 'devices.commands.update',
      Find: 'devices.commands.find',
    },
  },

  DeviceGroups: {
    View: 'device-groups.view',
    Manage: 'device-groups.manage',
  },

  Camera: {
    View: 'camera.preview.view',
    Manage: 'camera.preview.manage',

    Stream: {
      Status: 'camera.stream.status',
    },

    ExtruderPosition: {
      View: 'camera.preview.extruder-position.view',
      Manage: 'camera.preview.extruder-position.manage',
    },

    Multistream: {
      View: 'camera.multistream.view',
      Manage: 'camera.multistream.manage',
    },
  },

  Files: {
    View: 'files.view',
    Upload: 'files.upload',
    Download: 'files.download',
    Delete: 'files.delete',
  },

  Notifications: {
    View: 'notifications.view',
    Manage: 'notifications.manage',
  },

  Printing: {
    Direct: 'printing.direct',
    Multi: 'printing.multi',
  },

  Printout: {
    View: 'printout.view',
    Manage: 'printout.manage',
  },

  Shelves: {
    View: 'shelves.view',
    Manage: 'shelves.manage',
    Share: 'shelves.share',
  },

  SchedulerJobs: {
    View: 'scheduler-jobs.view',
    Manage: 'scheduler-jobs.manage',
  },

  Timeline: {
    View: 'timeline.view',
  },

  Statistics: {
    View: 'statistics.view',
    Export: 'statistics.export',
  },
} as const;

type NestedValue<T> = T extends string
  ? T
  : T extends Record<string, unknown>
  ? NestedValue<T[keyof T]>
  : never;

export type Permission = NestedValue<typeof PERMISSIONS>;
